import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

/**
 * List of all shorthand props that we need to convert to css
 */
var layoutProps = {
  $p: 'padding',
  $m: 'margin',
  $px: ['paddingLeft', 'paddingRight'],
  $mx: ['marginLeft', 'marginRight'],
  $py: ['paddingTop', 'paddingBottom'],
  $my: ['marginTop', 'marginBottom'],
  $pt: 'paddingTop',
  $mt: 'marginTop',
  $pr: 'paddingRight',
  $mr: 'marginRight',
  $pb: 'paddingBottom',
  $mb: 'marginBottom',
  $pl: 'paddingLeft',
  $ml: 'marginLeft'
};

var convertLayoutProps = function convertLayoutProps(values) {
  return Object.entries(layoutProps).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        cssProps = _ref2[1];

    var value = values[key];

    if (value === null || value === undefined) {
      return acc;
    }

    if (Array.isArray(cssProps)) {
      cssProps.forEach(function (p) {
        acc[p] = value;
      });
    } else {
      acc[cssProps] = value;
    }

    return acc;
  }, {});
};

export default convertLayoutProps;